<script setup>
import FavoritesPage from '@/components/FavoritesPage.vue';

</script>

<template>
  <Suspense>
    <FavoritesPage />
  </Suspense>
</template>
